import React, { useState } from 'react';

import { getSharableAttributes } from './helper';
import ManagedInput from 'components/form/managed_input';

import type { Contact } from 'bundles/backoffice/contacts/types';

interface SharedConfirmationProps {
  contact: Contact;
  onChange: (attributes: string[]) => void;
}

export default function SharedConfirmation({
  contact,
  onChange,
}: SharedConfirmationProps) {
  const [sharedAttributes, setSharedAttributes] = useState<string[]>([]);
  const toggleAttribute = (attribute: string) => {
    let newSharedAttributes;
    if (sharedAttributes.includes(attribute)) {
      newSharedAttributes = sharedAttributes.filter(attr => attr !== attribute);
    } else {
      newSharedAttributes = [...sharedAttributes, attribute];
    }
    setSharedAttributes(newSharedAttributes);
    onChange(newSharedAttributes);
  };
  const sharableAttributes = getSharableAttributes(contact);

  return (
    <div>
      <p>
        This will create a shared version of {contact.name} that other users will be able to see.
        What details would you like to include on this shared version?
      </p>
      {sharableAttributes.map(attr => (
        <ManagedInput
          checked={sharedAttributes.includes(attr.key)}
          key={attr.key}
          label={`${attr.label}: ${attr.getValue(contact)}`}
          type="checkbox"
          onChange={() => toggleAttribute(attr.key)}
        />
      ))}
    </div>
  );
}
